<td bitCell>
  {{ sponsoringOrg().familySponsorshipFriendlyName }}
</td>
<td bitCell>{{ sponsoringOrg().name }}</td>
<td bitCell>
  <span [class]="statusClass()">{{ statusMessage() }}</span>
</td>
<td bitCell>
  @if (!sponsoringOrg().familySponsorshipToDelete) {
    <button
      type="button"
      bitIconButton="bwi-ellipsis-v"
      buttonType="primaryGhost"
      [bitMenuTriggerFor]="appListDropdown"
      label="{{ 'options' | i18n }}"
    ></button>
  }
  <bit-menu #appListDropdown>
    @if (
      !isSelfHosted() &&
      !sponsoringOrg().familySponsorshipValidUntil &&
      !(isFreeFamilyPolicyEnabled$ | async)
    ) {
      <button
        type="button"
        bitMenuItem
        (click)="resendEmail()"
        [attr.aria-label]="'resendEmailLabel' | i18n: sponsoringOrg().familySponsorshipFriendlyName"
      >
        {{ "resendEmail" | i18n }}
      </button>
    }
    <button
      type="button"
      bitMenuItem
      variant="danger"
      (click)="revokeSponsorship()"
      [attr.aria-label]="
        'revokeAccountMessage' | i18n: sponsoringOrg().familySponsorshipFriendlyName
      "
    >
      {{ "remove" | i18n }}
    </button>
  </bit-menu>
</td>
